import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { QuoteVersions } from '../../model/quote/quote_versions.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../../quote.service';
import { ActivatedRoute } from "@angular/router";
import { GridOptions } from "ag-grid-community";
import { QuoteNotes } from '../../../../model/quote/quote_notes.model';

@Component({
  selector: 'app-admin-notes',
  templateUrl: './notes.component.html',
  styles: [
  ]
})
export class AlNotesComponent implements OnInit {
  @Input() quoteData: QuoteVersions;
  @Output() hasImportantNotes = new EventEmitter();
  notes = new QuoteNotes();
  quote;

  constructor(private quoteService: QuoteService, private modalService: NgbModal, private route: ActivatedRoute) { }
  ngOnChanges(changes: SimpleChanges) {

    this.quote = this.quoteData;
    // API - GET NOTES
    if (this.quote && this.quote.id) {
      this.quoteService.getNotes(this.quote.id)
        .subscribe(
          (response: any) => {
            this.rowData = response.result;
          });
    }
  }
  ngOnInit(): void {

  }

  // GET ENDORSEMENT
  gridOptions: GridOptions = {
    onGridReady: () => {
      this.gridOptions.api.sizeColumnsToFit();
    }
  };
  columnDefs = [
    {
      headerName: 'Notes', sortable: false, width: 120,
      cellRenderer: function (params) {
        return (params.data.is_important == 1) ? '<label class="badge badge-danger">Important</label> ' : '';

      }
    },
    { headerName: ' ', field: 'notes', sortable: true, width: 700 },
    {
      headerName: null,
      width: 120,
      cellRenderer: function (params) {
        let links = '<a title="Edit Notes" style="font-size: 18px;"><i class="mdi mdi-grease-pencil" data-action-type="edit" id="' + params.data.id + '"></i></a>';
        links += '<a title="Delete" style="font-size: 18px; margin-left: 20px;"><i class="mdi mdi-close-circle-outline text-danger" data-action-type="delete" id="' + params.data.id + '"></i></a>';
        return links;
      }
    }
  ];
  rowData: any;

  selectedRow;
  onGridRowClicked(e: any, content, deleteModel) {
    if (e) {

      let id = e.event.target.getAttribute("id");
      let actionType = e.event.target.getAttribute("data-action-type");
      switch (actionType) {
        case "edit":
          {

            const modalRef = this.modalService.open(content, { centered: true });
            this.notes = e.data;
            break;
          }
        case "delete": {
          this.modalService.open(deleteModel, { centered: true });
          this.selectedRow = this.gridOptions.api.getFocusedCell();
          this.notes = e.data;
        }
      }
    }
  }

  deleteNotes(id, selectedRow) {
    this.quoteService.deleteNotes(id)
      .subscribe(
        (response: any) => {
          this.modalService.dismissAll();
          this.gridOptions.rowData.splice(selectedRow.rowIndex, 1);
          this.gridOptions.api.setRowData(this.gridOptions.rowData);
        });
  }

  /*
  * ADD NOTES
  */
  openNotesPopup(content) {
    this.modalService.open(content, { centered: true });
    this.notes = new QuoteNotes();
  }

  saveNotes() {
    let data = {
      id: this.notes.id,
      quote_id: this.quote.id, //this.route.snapshot.params.quote_meta_id,
      notes: this.notes.notes,
      is_important: this.notes.is_important
    };
    this.quoteService.saveNotes(data)
      .subscribe(
        (response: any) => {
          if (this.notes.id == '') {
            this.gridOptions.rowData.push({
              'id': response.result.note_id,
              'notes': this.notes.notes,
              'is_important': this.notes.is_important,
            });
            this.gridOptions.api.setRowData(this.gridOptions.rowData);
            if (this.notes.is_important == 1) {
              this.hasImportantNotes.emit(true);
            }
          } else {
            this.gridOptions.api.refreshCells();
          }

          this.modalService.dismissAll();
        });
  }
}
